import './lib/jquery'

function stickTopLink() {
  if ($(window).scrollTop() + $(window).height() > $(document).height() - 52) {
    $('#top-link').addClass('fixed_top-link')
  } else {
    $('#top-link').removeClass('fixed_top-link')
  }
}
window.addEventListener('load', stickTopLink)
window.addEventListener('resize', stickTopLink)
document.addEventListener('DOMContentLoaded', () => {
  stickTopLink()
  $(window).scroll(() => {
    stickTopLink()
  })
  $(window).click(() => {
    stickTopLink()
  })
})
